export var DIALOG_CONTENT_CLASS_PREFIX = 'DialogContent';